import React from "react";
import Header from "@appComponents/Header/Header";
import { Layout, Tabs } from "antd";
import PrivateEquityPage from "./pages/PrivateEquityPage/PrivateEquityPage";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import PublicEquityPage from "./pages/PublicEquityPage/PublicEquityPage";

import * as style from "./SharesStyles.module.scss"

type Props = RouteComponentProps<{ subpage: string; slug: string }>;

const SharesApp = ({ match }: Props) => {
  const baseUrl = `/profile/${match.params.slug}/shares`;

  const tabs = React.useMemo(
    () => [
      {
        label: <Link to={`${baseUrl}/private-equity`}>Private Equity</Link>,
        key: "private-equity",
        children: <PrivateEquityPage />,
      },
      {
        label: <Link to={`${baseUrl}/public-equity`}>Public Equity</Link>,
        key: "public-equity",
        children: <PublicEquityPage />,
      },
    ],
    []
  );

  return (
    <>
      <Header padding="140 20" />
      <div className={style.wrapper}>
        <div className={style.layout}>
          <Layout className={style.layout}>
            <Layout.Content>
              <Tabs
                centered
                defaultActiveKey={match.params.subpage ?? "private-equity"}
                items={tabs}
                className={style.tabs}
              />
            </Layout.Content>
          </Layout>
        </div>
      </div>
    </>
  );
};

export default withRouter(SharesApp);
